module.exports = __webpack_public_path__ + "static/media/Logo The Lounge.1920548a.png";